import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { getBaseInfoList, addBaseInfoAsync, editBaseInfo, editBaseInfoAsync } from "../../../BaseInfo/store/api/BaseInfoApi";
import Checklist from "../../../Components/CheckList/Checklist";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

export default function ModalLabels({ show, setShow, onSelect, initLabels }) {
    const [labels, setLabels] = useState([]);

    const onAdd = async (item) => {
        const info = { InfoName: item.text, TypeID: 45 };
        const result = await addBaseInfoAsync(info);
        if (result.Data) {
            return ({ success: true, id: result.Data });
        }
        return ({ success: false });
    }
    const onUpdate = async (item) => {
        const result = await editBaseInfoAsync(item.id, item.text);
    }
    const close = () => {
        setShow(false);
    }
    useEffect(() => {
        if (show) {
            const existingIds = (initLabels ?? []).map((l) => Number(l.LabelId));
            const onGet = (result) => {
                if (result.Data) {
                    const lbls = result.Data.map(
                        (l) =>
                        (
                            {
                                text: l.InfoName,
                                id: l.ID,
                                done: existingIds.includes(Number(l.ID))
                            }
                        ));
                    setLabels(lbls);
                }
            }
            getBaseInfoList(45, onGet);
        }
    }, [show])
    if (!show) {
        return null;
    }
    return (
        <Modal show={show}>
            <Modal.Header className="headerStyle">
                <span>برچسب ها</span>
                <FontAwesomeIcon icon={faTimes} size="lg" onClick={close} />
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                <Checklist initialItems={labels} onAdd={onAdd} onUpdate={onUpdate} onToggle={onSelect} orderable={false} />
            </Modal.Body>
        </Modal>
    )
}